module.exports = __webpack_public_path__ + "img/logo (1).9a084852.png";